import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  getFilterRangeBetweenDates(diff_of_days: number, diff_of_months: number): string {
    let filter = 'hour';

    if (diff_of_days == 1) {
      filter = "hour";
    } else if (diff_of_days > 1 && diff_of_days <= 31) {
      filter = "day";
    } else if (diff_of_days > 31 && diff_of_days <= 90) {
      filter = "week";
    } else if (diff_of_days > 90 && diff_of_days < 366) {
      filter = "month";
    } else if (diff_of_months > 0 && diff_of_months <= 36) {
      filter = "month";
    } else if (diff_of_months > 36) {
      filter = "year";
    } else {
      filter = "year";
    }
    return filter;
  }

  getAxesLabelForRange(diff_of_days: number, diff_of_months: number): string {
    let label = 'Stunde';

    if (diff_of_days == 1) {
      label = "Stunde";
    } else if (diff_of_days > 1 && diff_of_days <= 31) {
      label = "Tag";
    } else if (diff_of_days > 31 && diff_of_days <= 90) {
      label = "Woche";
    } else if (diff_of_days > 90 && diff_of_days < 366) {
      label = "Monat";
    } else if (diff_of_months > 0 && diff_of_months <= 36) {
      label = "Monat";
    } else if (diff_of_months > 36) {
      label = "Jahr";
    } else {
      label = "Jahr";
    }
    return label;
  }

}
